<template>
  <Modal
    v-model="shows"
    :title="$t('status.index.756855-0')"
    ref="modal"
    draggable
    class-name="vertical-center-modal"
    :ok-text="$t('status.index.756855-1')"
    width="730"
    height="600"
    @on-cancel="shows = false"
  >
    <state-model v-if="shows" :data="data"></state-model>
  </Modal>
</template>

<script>
import StateModel from './state.vue'

export default {
  components: {
    StateModel
  },
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false
    },
    data: {
      type: Object
    }
  },
  computed: {
    shows: {
      get() {
        return this.show;
      },
      set(newValue) {
        this.$emit("update:show", newValue);
      }
    }
  },
};
</script>




// WEBPACK FOOTER //
// src/components/useGas/views/device/mods/status/index.vue